'use client';
import isEqual from 'lodash/isEqual';
import { useEffect } from 'react';
import useGeoLocationContext from '../../../../hooks/useUserContext/useGeoLocationContext';
import { useGetGlobalAppStateStoreState } from '../../../../stores/app/GlobalAppStateStore';
import { useSetDeviceContext } from './helperHooks/useSetDeviceContext';

export function useInitialiseGeolocation({
  isGeoLocationTrackingEnabled,
}: {
  isGeoLocationTrackingEnabled: boolean;
}) {
  const { geoLocation, isLoadingGeoLocation } = useGeoLocationContext({
    isGeoLocationTrackingEnabled,
  });
  const { getGlobalAppStateStoreState } = useGetGlobalAppStateStoreState();
  const { setDeviceContext } = useSetDeviceContext();

  useEffect(() => {
    const currentLocation = getGlobalAppStateStoreState().deviceContext.location;

    if (isLoadingGeoLocation || !geoLocation || isEqual(currentLocation, geoLocation)) {
      return;
    }

    // refer: apps/platform/src/modules/interfaces/views/InterfaceBuilder/components/BuilderInputDataPanelProvider/hooks/useGetUserSchema.ts
    // for schema
    // Set location (legacy `geography`) in nocode deviceContext
    setDeviceContext({ location: geoLocation });
  }, [isLoadingGeoLocation, geoLocation, setDeviceContext, getGlobalAppStateStoreState]);
}
